import {
  PayoutInfo as KitPayoutInfo,
  RightIcon,
} from "lola-framework-ui-test";
import type { JSX } from "react";

export interface PayoutInfoProps {
  title: string;
  subtitle: string;
  icon: JSX.Element;
  onChange?: () => void;
  background?: string;
  color?: string;
  fee?: string | JSX.Element;
  className?: string;
}

export const PayoutInfo: React.FC<PayoutInfoProps> = ({
  title,
  subtitle,
  icon,
  onChange,
  background,
  color = "#252525",
  fee,
  className = "",
}) => (
  <KitPayoutInfo
    title={title}
    subtitle={subtitle}
    icon={icon}
    onChange={onChange}
    iconColor={color}
    fee={fee ?? <RightIcon size={30} colors={[color, color]} />}
    className={className}
    background={background}
  />
);
